import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import PropTypes from 'prop-types';

export default function CustomButton({
  value,
  handleSubmit,
  backgroundColor,
  color,
  borderColor,
  fontWeight,
  containerBoxStyle,
  width,
  height,
  transition,
  disableNextPrev,
  isSecondary,
}) {
  const buttonSx = {
    border: disableNextPrev ? undefined : `1px solid ${borderColor}`,
    backgroundColor: disableNextPrev ? '#E4E4E8' : backgroundColor,
    color: disableNextPrev ? '#76767A' : color,
    borderRadius: '2px',
    boxSizing: 'border-box',
    borderColor,
    width,
    height,
    transition,
    fontWeight,
  };
  return (
    <Box className={`${containerBoxStyle}`}>
      <Button
        className={isSecondary ? 'secondaryButtonStyle' : 'buttonStyle'}
        sx={buttonSx}
        variant="contained"
        onClick={handleSubmit}
        disabled={disableNextPrev}
      >
        <Typography
          style={{
            fontWeight,
            fontSize: '16px',
            lineHeight: '20px',
          }}
        >
          {value}
        </Typography>
      </Button>
    </Box>
  );
}

CustomButton.defaultProps = {
  color: 'white',
  backgroundColor: '#1D6460',
  borderColor: '#1D6460',
  fontWeight: 'normal',
  width: '122px',
  height: '48px',
  transition: 'none',
  containerBoxStyle: 'enterBtnBox mobEnterBtnBox',
  isSecondary: false,
};

CustomButton.propTypes = {
  value: PropTypes.string.isRequired,
  backgroundColor: PropTypes.string,
  color: PropTypes.string,
  fontWeight: PropTypes.string,
  borderColor: PropTypes.string,
  handleSubmit: PropTypes.func.isRequired,
  containerBoxStyle: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  transition: PropTypes.string,
  disableNextPrev: PropTypes.bool.isRequired,
  isSecondary: PropTypes.bool,
};
